import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Components/HomeComponents/Home';
import MainSchedule from './Components/Schedule/MainSchedule';
import Monday from './Components/Schedule/MainSchedule/Monday';
import DaySchedule from './Components/Schedule/DaySchedule';
import CourseHome from './Components/Courses/CourseHome';
import ContactPage from './Components/Contact/ContactPage';
import Ask from './Components/AskMe/Ask';
import Thanks from './Components/Contact/Thanks';
import Ninth from './Components/Questions/Classes/Ninth/Ninth';
import Tenth from './Components/Questions/Classes/Tenth/Tenth';
// import Eleventh from './Components/Questions/Classes/Eleventh';
// import Twelvth from './Components/Questions/Classes/Twelvth';
// import Question from './Components/Questions/Classes/Question';
import CourseHomeM from './Components/Courses/CourseHomeM';
import TenthPhysics from './Components/Questions/Classes/Tenth/TenthPhysics';
import TenthChemistry from './Components/Questions/Classes/Tenth/TenthChemisrty';
import TenthBiology from './Components/Questions/Classes/Tenth/TenthBiology';
import CourseHomeMT from './Components/Courses/CourseHomeMT';
import CourseHomeF from './Components/Courses/CourseHomeF';


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route exact path="/Schedule" element={<MainSchedule key={"/"} />}></Route>
          <Route exact path="/fetch" element={<Monday key={"/fetch"} />}></Route>
          <Route exact path="/day" element={<DaySchedule key={"/day"} />}></Route>
          <Route exact path="/courses" element={<CourseHomeM key={"/courses"} />}></Route>
          <Route exact path="/contact" element={<ContactPage key={"/contact"} />}></Route>
          <Route exact path="/ask" element={<Ask key={"/ask"} />}></Route>
          <Route exact path="/thanks" element={<Thanks key={"/thanks"} />}></Route>
          <Route exact path="/questions" element={<Ninth key={"/questions"} />}></Route>

          
          
          <Route exact path="/question/7" element={<Ninth key={"/question/7"} />}></Route>
          <Route exact path="/question/8" element={<Ninth key={"/question/8"} />}></Route>
          <Route exact path="/question/9" element={<Ninth key={"/question/9"} />}></Route>
          <Route exact path="/question/10" element={<Tenth key={"/question/10"} />}></Route>
          {/* <Route exact path="/question/11" element={<Eleventh key={"/question/11"} />}></Route>
          <Route exact path="/question/12" element={<Twelvth key={"/question/12"} />}></Route> */}
         
         
         
          <Route exact path="/tenth/physics" element={<TenthPhysics key={"/tenth/physics"} />}></Route>
          <Route exact path="/tenth/chemistry" element={<TenthChemistry key={"/tenth/chemistry"} />}></Route>
          <Route exact path="/tenth/biology" element={<TenthBiology key={"/tenth/biology"} />}></Route>





        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
